// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"fc9c1f69","977":"8f9d1098"}[chunkId] + ".chunk.css";
};